import { en } from './en';
import { de } from './de';
import { es } from './es';
import { fr } from './fr';
import { pt } from './pt';
import { it } from './it';

export const translations = {
  en,
  de,
  es,
  fr,
  pt,
  it,
} as const;
